import React, { useState } from "react";
import { doc, setDoc, serverTimestamp } from "firebase/firestore";
import { getStorage, ref, uploadBytesResumable, getDownloadURL } from "firebase/storage";
import { firestore } from "../../pagini/Firebase"; // Asigură-te că `getAuth` și `getUserByEmail` sunt corect implementate
import { getFirestore, getDoc } from "firebase/firestore";
import { getFunctions, httpsCallable } from "firebase/functions";
import { useTranslation } from "react-i18next";
import "../stiluri/CreateUserPopup.css"; // Importă CSS-ul

// Funcția pentru setarea custom claims
const setCustomClaims = async (email, role, sectiuni) => {
  const functions = getFunctions();
  const setUserRole = httpsCallable(functions, "setUserRole");

  const firestore = getFirestore();
  const querySnapshot = await getDoc(doc(firestore, "Utilizatori", email)); // Folosim CNP-ul sau email-ul ca ID al documentului

  const userData = querySnapshot.data();
  const uid = userData?.authUid; // sau alt câmp unde salvezi uid-ul Firebase Auth

  if (!uid) {
    console.error("UID lipsă în Firestore pentru utilizator:", email);
    return;
  }

  await setUserRole({
    uid,
    role,
    sectiuni,
  });
};

// Componenta pentru crearea unui utilizator nou
const CreateUserPopup = ({ onClose, onCreate }) => {
  const [newUser, setNewUser] = useState({
    cnp: "",
    nume: "",
    prenume: "",
    email: "",
    telefon: "",
    functie: "",
    institutie: "",
    role: "",
    creat_la: null,
    ultima_autentificare: null,
    activ: true,
    notite_admin: "",
    avatar_url: "",
    istoric_actiuni: [],
    verificat: false,
  });

  const [avatarProgress, setAvatarProgress] = useState(0); // Pentru progresul încărcării
const { t } = useTranslation();
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (type === "checkbox") {
      setNewUser((prev) => ({
        ...prev,
        [name]: checked,
      }));
    } else {
      setNewUser((prev) => ({
        ...prev,
        [name]: value,
      }));
    }
  };

  // Funcția de salvare a utilizatorului
  const handleSave = async () => {
if (!newUser.cnp) {
  alert(t("cnpRequired"));
}
if (!newUser.email || !newUser.email.includes("@")) {
  alert(t("validEmail"));
}

    try {
      const userToSave = {
        ...newUser,
        creat_la: serverTimestamp(),
      };

      // Salvează utilizatorul în Firestore
      await setDoc(doc(firestore, "Utilizatori", newUser.cnp), userToSave);

      // Setează custom claims pentru utilizator
      await setCustomClaims(newUser.email, newUser.role, []);

      // Apelează funcția onCreate pentru a înregistra utilizatorul
      if (onCreate) onCreate(newUser.cnp); // Verifică că onCreate este o funcție

      // Închide fereastra popup și afișează mesajul de succes
      onClose();
      alert("Utilizator creat cu succes!");
    } catch (error) {
      console.error("Error creating user:", error);
      alert("A apărut o eroare la crearea utilizatorului.");
    }
  };

  // Funcția de încărcare a avatarului
  const handleAvatarUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Verificăm dacă CNP-ul este completat
    if (!newUser.cnp) {
      alert("Completează CNP-ul înainte de a încărca o imagine.");
      return;
    }

    const storage = getStorage();
    // Calea completă a fișierului: /Utilizatori/<cnp>/poza_profil/poza.jpg
    const storageRef = ref(storage, `Utilizatori/${newUser.cnp}/poza_profil/${file.name}`);

    const uploadTask = uploadBytesResumable(storageRef, file);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // Calculăm progresul
        const progress = (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
        setAvatarProgress(progress);
      },
      (error) => {
        console.error("Eroare la încărcarea avatarului:", error);
        alert("Eroare la încărcarea avatarului.");
      },
      async () => {
        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref());
        // Actualizăm URL-ul avatarului în starea utilizatorului
        setNewUser((prev) => ({
          ...prev,
          avatar_url: downloadURL,
        }));
      }
    );
  };

  return (
    <div className="popup-create-user">
      <div className="popup-content-create-user">
<h3>{t("createNewUser")}</h3>

        <input
          className="create-user-input"
          type="text"
          name="cnp"
          placeholder={t("cnpPlaceholder")}
          value={newUser.cnp}
          onChange={handleChange}
          required
        />
        <input
          className="create-user-input"
          type="text"
          name="nume"
          placeholder={t("lastName")} 
          value={newUser.nume}
          onChange={handleChange}
        />
        <input
          className="create-user-input"
          type="text"
          name="prenume"
          placeholder={t("firstName")}
          value={newUser.prenume}
          onChange={handleChange}
        />
        <input
          className="create-user-input"
          type="text"
          name="email"
          placeholder={t("email")}
          value={newUser.email}
          onChange={handleChange}
        />
        <input
          className="create-user-input"
          type="text"
          name="telefon"
          placeholder={t("phone")}
          value={newUser.telefon}
          onChange={handleChange}
        />
        <input
          className="create-user-input"
          type="text"
          name="functie"
          placeholder={t("function")}
          value={newUser.functie}
          onChange={handleChange}
        />
        <input
          className="create-user-input"
          type="text"
          name="institutie"
          placeholder={t("institution")}
          value={newUser.institutie}
          onChange={handleChange}
        />

        <select
          className="create-user-input"
          name="role"
          value={newUser.role}
          onChange={handleChange}
        >
  <option value="">{t("selectRole")}</option>
  <option value="administrator">{t("administrator")}</option>
  <option value="utilizator">{t("user")}</option>
  <option value="director">{t("director")}</option>
        </select>

        {/* Caseta de upload pentru avatar */}
        <div>
     <h4>{t("profilePicture")}</h4>
          <input
            className="create-user-input"
            type="file"
            accept="image/*"
            onChange={handleAvatarUpload}
          />
          {avatarProgress > 0 && avatarProgress < 100 && (
            <div className="progress-bar">
              <div
                className="progress-bar-fill"
                style={{ width: `${avatarProgress}%` }}
              ></div>
            </div>
          )}
        </div>

        <button className="create-user-button create-user-button-save" onClick={handleSave}>
          {t("save")}
        </button>
        <button className="create-user-button create-user-button-close" onClick={onClose}>
         {t("close")}
        </button>
      </div>
    </div>
  );
};

export default CreateUserPopup;
